// @ts-nocheck
import React from 'react';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import PowerControlUnitEventsView from './PowerControlUnitEventsView.jsx';

class PowerControlUnitHistoryView extends React.Component {
  render() {
    return (
      <FormFlatContainer title="eventHistory" containerStyle={{ marginRight: 10 }}>
        <PowerControlUnitEventsView />
      </FormFlatContainer>
    );
  }
}

export default PowerControlUnitHistoryView;
